import { FunctionComponent, useState } from "react";
import { Box, IconButton } from "@chakra-ui/react";
import { Helmet } from "react-helmet";
import ReactPlayer from "react-player";
import { MdClose } from "react-icons/md";

import ExclusivePage from "src/Modules/pages/RadarSpotlight/Exclusive";

import Trending from "src/Modules/pages/RadarSpotlight/Trending";
import LatestHappenings from "src/Modules/pages/RadarSpotlight/LatestHappenings";

const RadarSpotlight: FunctionComponent = () => {
  const [isShowExclusiveVideo, setIsShowExclusiveVideo] = useState(false);
  const [exclusiveVideoUrl, setExclusiveVideoUrl] = useState("");

  const handleCloseExclusiveVideo = () => {
    setIsShowExclusiveVideo(false);
    setExclusiveVideoUrl("");
  };

  const handleViewVideo = (url: string) => {
    setIsShowExclusiveVideo(true);
    setExclusiveVideoUrl(url);
  };

  return (
    <>
      <Helmet>
        <title>Radar Spotlight</title>
      </Helmet>
      <Box>
        <Trending />
        <LatestHappenings />
        <ExclusivePage handleViewVideo={handleViewVideo} />

        {isShowExclusiveVideo && (
          <Box
            position={"fixed"}
            top={0}
            background={"#8080804a"}
            width={"100%"}
            left={0}
            right={0}
            height={"100vh"}
            zIndex={10}
          >
            <Box
              width={"fit-content"}
              transform={"translate(60%, 60%)"}
              borderRadius={"8px"}
              overflow={"hidden"}
            >
              <Box textAlign={"end"} mb={2}>
                <IconButton
                  isRound
                  aria-label="done"
                  icon={<MdClose />}
                  fontSize={"20px"}
                  size={"sm"}
                  onClick={handleCloseExclusiveVideo}
                />
              </Box>
              <ReactPlayer
                url={exclusiveVideoUrl}
                controls
                playing
                style={{ backgroundColor: "#3e3d3d", borderRadius: "8px" }}
              />
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default RadarSpotlight;
